jQuery(function($) { // jQuery init

	$('.selectric').selectric();
	$(".selectric-input").wrap('<label class="hide" aria-hidden="true">Label</label>');
	$('#coupon_code').attr('aria-label', 'Coupon code');

	// mobile chapter topic collapsing
	$('.mobile-quicklinks-collapsible').on('click', function() {
		var $this = $(this);

		$this.toggleClass('active')
			.next('.ch-quicklinks').slideToggle('fast');
	});

	$('form').parsley();

	// // subscription panel
	// $('.subscription-plan').on('change', function(e) {
	// 	e.preventDefault();
	// 	var $this = $(this);
	// 	if ( $this.val() ) {
	// 		var href = '/?add-to-cart=' + $this.val();
	// 		$this.closest('form').find('.btn-buynow').attr('href', href).removeClass('no-event');
	// 	} else {
	// 		$this.closest('form').find('.btn-buynow').attr('href', '#').addClass('no-event');
	// 	}
	// });

	$('.target-blank').on('click', function(e) {
		e.preventDefault();
		window.open($(this).attr('href'), '_blank');
	});

	$('.not-subscriber').find('sup').hide();


	//Handle the multiple subscriptions
	$(document).on('click', '.pricing-plan .cta-purchase', function (e) {
		e.preventDefault();
		const priceCol =  $(this).parent();
		if (priceCol.find('select[name="subscription_quantity"]').length > 0) {
			//Has a quantity field
			const quantityField = priceCol.find('select[name="subscription_quantity"]');
			if (quantityField.val() == "") {
				//validate
				quantityField.addClass('error');
				quantityField.prev().addClass('error');
				priceCol.find('.plan-price-total').text("");
			}
			else {
				//Do price change and add to cart.
				$.post($(this).attr('href') + "&licences=" + quantityField.val() , function (data) {
						document.location = "/checkout";
				});
			}
		}
		else {
			document.location = $(this).attr('href');
		}
	});

	$(document).on('change', 'select[name="subscription_quantity"]', function (e) {
		
		const priceCol =  $(this).closest('.price-col');
		const price =  priceCol.find('.plan-price').text();
		if ($(this).val() !== "") {
			var finalPrice = parseFloat(price) * parseFloat($(this).val());
			priceCol.find('.plan-price-total').text("$" + finalPrice.toFixed(2));
		}
		else {
			priceCol.find('.plan-price-total').text("");
		}

	});

});
